unit uEditOtazky;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.REST, WEBLib.JSON, System.NetEncoding, WEBLib.Buttons, WEBLib.ExtCtrls,
  WEBLib.CDS;

type
  TfEditOtazky = class(TForm)
    eRozsah: TEdit;
    eCislo: TEdit;
    cbSpravnaA: TCheckBox;
    cbSpravnaB: TCheckBox;
    cbSpravnaC: TCheckBox;
    cbSpravnaD: TCheckBox;
    cbSpravnaE: TCheckBox;
    cbSpravnaF: TCheckBox;
    cbSpravnaG: TCheckBox;
    cbSpravnaH: TCheckBox;

    WebPanel1: TPanel;
    WebClientConnection3: TClientConnection;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    mTextOtazky: TMemo;
    eOdpovedA: TMemo;
    eOdpovedB: TMemo;
    eOdpovedC: TMemo;
    eOdpovedD: TMemo;
    eOdpovedE: TMemo;
    eOdpovedF: TMemo;
    eOdpovedG: TMemo;
    eOdpovedH: TMemo;
    WebLabel13: TLabel;
    btnUlozit: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    [async]
    procedure btnUlozitClick(Sender: TObject); async;
    procedure WebClientConnection3DataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    [async]
    procedure WebFormShow(Sender: TObject); async;
    procedure WebSpeedButton2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    VybranyPredmet: string;
    otazkanova : boolean;
    OtazkaID : integer;
  protected procedure LoadDFMValues; override; end;

var
  fEditOtazky: TfEditOtazky;

implementation

{$R *.dfm}



procedure TfEditOtazky.btnUlozitClick(Sender: TObject);
var
  res: boolean;
  JsonPayload: string;
 //txtOtazka: string;
begin
  // Ošetrenie enterov z Mema, aby ti JSON nezasekol sieť (tvoj overený JS stringify trik)
{  asm
    var clean = JSON.stringify(this.mTextOtazky.FText);
    txtOtazka = clean.substring(1, clean.length - 1);
  end;}
  if OtazkaNova then
  begin
    // 1. Najprv poskladáme čistý JSON text pre novú otázku do premennej
    JsonPayload := '{"PREDMET":"' + VybranyPredmet + '",'+
                    '"ROZSAH":"' + eRozsah.text + '",'+
                    '"CISLO_OTAZKY":"' + eCislo.text + '",'+
                    '"TEXT_OTAZKY":"' + mTextOtazky.Text + '",'+
                    '"ODPOVEDE":['+
                      '{"PISMENO":"a","TEXT":"' + eOdpovedA.text + '","OK":"' + BoolToStr(cbSpravnaA.Checked, True) + '"},'+
                      '{"PISMENO":"b","TEXT":"' + eOdpovedB.text + '","OK":"' + BoolToStr(cbSpravnaB.Checked, True) + '"},'+
                      '{"PISMENO":"c","TEXT":"' + eOdpovedC.text + '","OK":"' + BoolToStr(cbSpravnaC.Checked, True) + '"},'+
                      '{"PISMENO":"d","TEXT":"' + eOdpovedD.text + '","OK":"' + BoolToStr(cbSpravnaD.Checked, True) + '"},'+
                      '{"PISMENO":"e","TEXT":"' + eOdpovedE.text + '","OK":"' + BoolToStr(cbSpravnaE.Checked, True) + '"},'+
                      '{"PISMENO":"f","TEXT":"' + eOdpovedF.text + '","OK":"' + BoolToStr(cbSpravnaF.Checked, True) + '"},'+
                      '{"PISMENO":"g","TEXT":"' + eOdpovedG.text + '","OK":"' + BoolToStr(cbSpravnaG.Checked, True) + '"},'+
                      '{"PISMENO":"h","TEXT":"' + eOdpovedH.text + '","OK":"' + BoolToStr(cbSpravnaH.Checked, True) + '"'+'}'+
                    ']'+ // <--- TU SME SPRÁVNE UZAVRELI STRUKTÚRU JSON-U
                  '}';
    WebClientConnection3.close;
    WebClientConnection3.URI := 'http://' + window.location.hostname + ':8080/pridajotazku';
    WebClientConnection3.Command := httpPOST;
    // 2. 🔥 ŠIFROVANIE DÁT DO BASE64 PRE NOVÚ OTÁZKU:
    asm
      var utf8Bytes = encodeURIComponent(JsonPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) {
          return String.fromCharCode('0x' + p1);
      });
      this.WebClientConnection3.FPostData = btoa(utf8Bytes);
    end;
    // 3. Asynchrónne odoslanie do siete cez tvoje TAwait
    res := Await(boolean, WebClientConnection3.Open);
  end
  else
  begin
    // 1. Poskladáme štrukturálne čistý JSON pre UPDATE (opravený záver riadku "h")
    JsonPayload := '{"OTAZKA_ID":' + inttostr(OtazkaID) + ','+
                    '"PREDMET":"' + VybranyPredmet + '",'+
                    '"ROZSAH":"' + eRozsah.text + '",'+
                    '"CISLO_OTAZKY":"' + eCislo.text + '",'+
                    '"TEXT_OTAZKY":"' + mTextOtazky.Text + '",'+
                    '"ODPOVEDE":['+
                      '{"PISMENO":"a","TEXT":"' + eOdpovedA.text + '","OK":"' + BoolToStr(cbSpravnaA.Checked, True) + '"},'+
                      '{"PISMENO":"b","TEXT":"' + eOdpovedB.text + '","OK":"' + BoolToStr(cbSpravnaB.Checked, True) + '"},'+
                      '{"PISMENO":"c","TEXT":"' + eOdpovedC.text + '","OK":"' + BoolToStr(cbSpravnaC.Checked, True) + '"},'+
                      '{"PISMENO":"d","TEXT":"' + eOdpovedD.text + '","OK":"' + BoolToStr(cbSpravnaD.Checked, True) + '"},'+
                      '{"PISMENO":"e","TEXT":"' + eOdpovedE.text + '","OK":"' + BoolToStr(cbSpravnaE.Checked, True) + '"},'+
                      '{"PISMENO":"f","TEXT":"' + eOdpovedF.text + '","OK":"' + BoolToStr(cbSpravnaF.Checked, True) + '"},'+
                      '{"PISMENO":"g","TEXT":"' + eOdpovedG.text + '","OK":"' + BoolToStr(cbSpravnaG.Checked, True) + '"},'+
                      '{"PISMENO":"h","TEXT":"' + eOdpovedH.text + '","OK":"' + BoolToStr(cbSpravnaH.Checked, True) + '"'+'}'+
                    ']'+
                  '}';
    WebClientConnection3.close;
    WebClientConnection3.URI := 'http://' + window.location.hostname + ':8080/upravotazku';
    WebClientConnection3.Command := httpPOST;
    // --- PO NOVOM: ŽIADNE "asm btoa" ŠIFROVANIE! Priradíme čistý text napriamo ---
    WebClientConnection3.PostData := JsonPayload;
    // 2. Vystrelíme čisté dáta do siete cez tvoje overené TAwait
    res := Await(boolean, WebClientConnection3.Open);
  end;

  if res then
  begin
    ShowMessage('Otázka bola úspešne uložená do databázy!');
    ModalResult := mrOk;
  end
  else
    ShowMessage('Chyba pri komunikácii so serverom.');
end;


procedure TfEditOtazky.WebClientConnection3DataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
{if AResponse = '200' then
 close;}

  if Pos('"status":"ok"', AResponse) > 0 then
  begin
    ModalResult := mrOk; // Povie hlavnému gridu, aby sa po zatvorení hneď znova načítal
    Close;
  end;

end;


[async]
procedure TfEditOtazky.WebFormShow(Sender: TObject); async;
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  JS: TJSON;
  JO, JOAns: TJSONObject;
  JA: TJSONArray;
  i: integer;
  pismeno, textAns, jeSpravnaText: string;
begin
  if otazkanova then
  begin
    eRozsah.Text := '';
    eCislo.Text := '';
    mTextOtazky.Text := '';
    // Vyčistíme všetkých 8 textov odpovedí
    eOdpovedA.Text := '';
    eOdpovedB.Text := '';
    eOdpovedC.Text := '';
    eOdpovedD.Text := '';
    eOdpovedE.Text := '';
    eOdpovedF.Text := '';
    eOdpovedG.Text := '';
    eOdpovedH.Text := '';
    // Vynulujeme všetky CheckBoxy správnosti
    cbSpravnaA.Checked := False;
    cbSpravnaB.Checked := False;
    cbSpravnaC.Checked := False;
    cbSpravnaD.Checked := False;
    cbSpravnaE.Checked := False;
    cbSpravnaF.Checked := False;
    cbSpravnaG.Checked := False;
    cbSpravnaH.Checked := False;
    // Ukončíme procedúru, aby web zbytočne nesťahoval dáta zo servera
    Exit;
  end;
  // Čítame po novom v čistom texte cez TWebHttpRequest
  wr := THttpRequest.Create(nil);
  wr.Command := httpPOST;
  wr.URL := 'http://' + window.location.hostname + ':8080/nacitajotazku';
  wr.PostData := '{"OTAZKA_ID":"' + IntToStr(OtazkaID) + '"}';
  res := await(TJSXMLHttpRequest, wr.Perform);
  JS := TJSON.Create;
  try
    // PO NOVOM: Žiadne Base64.Decode, parsujeme rovno surový responseText zo siete!
    JO := TJSONObject(JS.Parse(res.responseText));
    if JO <> nil then
    begin
      eRozsah.Text := JO.GetJSONValue('ROZSAH');
      eCislo.Text := JO.GetJSONValue('CISLO_OTAZKY');
      mTextOtazky.Text := JO.GetJSONValue('TEXT_OTAZKY');
      JA := TJSONArray(JO.Get('ODPOVEDE').JsonValue);
      if JA <> nil then
      begin
        for i := 0 to JA.Count - 1 do
        begin
          JOAns := TJSONObject(JA.Items[i]);
          pismeno := JOAns.GetJSONValue('PISMENO');
          textAns := JOAns.GetJSONValue('TEXT');
          jeSpravnaText := JOAns.GetJSONValue('OK');
          if pismeno = 'a' then begin eOdpovedA.Text := textAns; cbSpravnaA.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'b' then begin eOdpovedB.Text := textAns; cbSpravnaB.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'c' then begin eOdpovedC.Text := textAns; cbSpravnaC.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'd' then begin eOdpovedD.Text := textAns; cbSpravnaD.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'e' then begin eOdpovedE.Text := textAns; cbSpravnaE.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'f' then begin eOdpovedF.Text := textAns; cbSpravnaF.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'g' then begin eOdpovedG.Text := textAns; cbSpravnaG.Checked := (jeSpravnaText = '1'); end;
          if pismeno = 'h' then begin eOdpovedH.Text := textAns; cbSpravnaH.Checked := (jeSpravnaText = '1'); end;
        end;
      end;
    end;
  finally
    JS.Free;
  end;
  wr.Free;
end;
procedure TfEditOtazky.WebSpeedButton2Click(Sender: TObject);
begin
ModalResult := mrOk;
end;

procedure TfEditOtazky.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  eRozsah := TEdit.Create(Self);
  eCislo := TEdit.Create(Self);
  cbSpravnaA := TCheckBox.Create(Self);
  cbSpravnaB := TCheckBox.Create(Self);
  cbSpravnaC := TCheckBox.Create(Self);
  cbSpravnaD := TCheckBox.Create(Self);
  cbSpravnaE := TCheckBox.Create(Self);
  cbSpravnaF := TCheckBox.Create(Self);
  cbSpravnaG := TCheckBox.Create(Self);
  cbSpravnaH := TCheckBox.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnUlozit := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  mTextOtazky := TMemo.Create(Self);
  eOdpovedA := TMemo.Create(Self);
  eOdpovedB := TMemo.Create(Self);
  eOdpovedC := TMemo.Create(Self);
  eOdpovedD := TMemo.Create(Self);
  eOdpovedE := TMemo.Create(Self);
  eOdpovedF := TMemo.Create(Self);
  eOdpovedG := TMemo.Create(Self);
  eOdpovedH := TMemo.Create(Self);
  WebClientConnection3 := TClientConnection.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  eRozsah.BeforeLoadDFMValues;
  eCislo.BeforeLoadDFMValues;
  cbSpravnaA.BeforeLoadDFMValues;
  cbSpravnaB.BeforeLoadDFMValues;
  cbSpravnaC.BeforeLoadDFMValues;
  cbSpravnaD.BeforeLoadDFMValues;
  cbSpravnaE.BeforeLoadDFMValues;
  cbSpravnaF.BeforeLoadDFMValues;
  cbSpravnaG.BeforeLoadDFMValues;
  cbSpravnaH.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnUlozit.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  mTextOtazky.BeforeLoadDFMValues;
  eOdpovedA.BeforeLoadDFMValues;
  eOdpovedB.BeforeLoadDFMValues;
  eOdpovedC.BeforeLoadDFMValues;
  eOdpovedD.BeforeLoadDFMValues;
  eOdpovedE.BeforeLoadDFMValues;
  eOdpovedF.BeforeLoadDFMValues;
  eOdpovedG.BeforeLoadDFMValues;
  eOdpovedH.BeforeLoadDFMValues;
  WebClientConnection3.BeforeLoadDFMValues;
  try
    Name := 'fEditOtazky';
    Width := 928;
    Height := 882;
    Color := 16763647;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 184;
    WebLabel1.Top := 27;
    WebLabel1.Width := 43;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Rozsah :';
    WebLabel1.Color := 16763647;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 184;
    WebLabel2.Top := 54;
    WebLabel2.Width := 32;
    WebLabel2.Height := 15;
    WebLabel2.Caption := #268#237'slo :';
    WebLabel2.Color := 16763647;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 184;
    WebLabel3.Top := 86;
    WebLabel3.Width := 42;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Ot'#225'zka :';
    WebLabel3.Color := 16763647;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 184;
    WebLabel4.Top := 174;
    WebLabel4.Width := 56;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Odpove'#271' :';
    WebLabel4.Color := 16763647;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 240;
    WebLabel5.Top := 200;
    WebLabel5.Width := 10;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'a)';
    WebLabel5.Color := 16763647;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 240;
    WebLabel6.Top := 271;
    WebLabel6.Width := 11;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'b)';
    WebLabel6.Color := 16763647;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 240;
    WebLabel7.Top := 342;
    WebLabel7.Width := 10;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'c)';
    WebLabel7.Color := 16763647;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 240;
    WebLabel8.Top := 413;
    WebLabel8.Width := 11;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'd)';
    WebLabel8.Color := 16763647;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 240;
    WebLabel9.Top := 484;
    WebLabel9.Width := 10;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'e)';
    WebLabel9.Color := 16763647;
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(Self);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 240;
    WebLabel10.Top := 555;
    WebLabel10.Width := 8;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'f)';
    WebLabel10.Color := 16763647;
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 240;
    WebLabel11.Top := 626;
    WebLabel11.Width := 11;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'g)';
    WebLabel11.Color := 16763647;
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 240;
    WebLabel12.Top := 697;
    WebLabel12.Width := 11;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'h)';
    WebLabel12.Color := 16763647;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 800;
    WebLabel13.Top := 174;
    WebLabel13.Width := 48;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'Spr'#225'vna :';
    WebLabel13.Color := 16763647;
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    eRozsah.SetParentComponent(Self);
    eRozsah.Name := 'eRozsah';
    eRozsah.Left := 272;
    eRozsah.Top := 16;
    eRozsah.Width := 121;
    eRozsah.Height := 25;
    eRozsah.Font.Charset := DEFAULT_CHARSET;
    eRozsah.Font.Color := clWindowText;
    eRozsah.Font.Height := -17;
    eRozsah.Font.Name := 'Segoe UI';
    eRozsah.Font.Style := [];
    eRozsah.HeightPercent := 100.000000000000000000;
    eRozsah.ParentFont := False;
    eRozsah.Text := 'eRozsah';
    eRozsah.WidthPercent := 100.000000000000000000;
    eCislo.SetParentComponent(Self);
    eCislo.Name := 'eCislo';
    eCislo.Left := 272;
    eCislo.Top := 47;
    eCislo.Width := 121;
    eCislo.Height := 25;
    eCislo.ChildOrder := 1;
    eCislo.Font.Charset := DEFAULT_CHARSET;
    eCislo.Font.Color := clWindowText;
    eCislo.Font.Height := -17;
    eCislo.Font.Name := 'Segoe UI';
    eCislo.Font.Style := [];
    eCislo.HeightPercent := 100.000000000000000000;
    eCislo.ParentFont := False;
    eCislo.Text := 'eRozsah';
    eCislo.WidthPercent := 100.000000000000000000;
    cbSpravnaA.SetParentComponent(Self);
    cbSpravnaA.Name := 'cbSpravnaA';
    cbSpravnaA.Left := 852;
    cbSpravnaA.Top := 216;
    cbSpravnaA.Width := 25;
    cbSpravnaA.Height := 22;
    cbSpravnaA.ChildOrder := 11;
    cbSpravnaA.HeightPercent := 100.000000000000000000;
    cbSpravnaA.WidthPercent := 100.000000000000000000;
    cbSpravnaB.SetParentComponent(Self);
    cbSpravnaB.Name := 'cbSpravnaB';
    cbSpravnaB.Left := 852;
    cbSpravnaB.Top := 288;
    cbSpravnaB.Width := 25;
    cbSpravnaB.Height := 22;
    cbSpravnaB.ChildOrder := 11;
    cbSpravnaB.HeightPercent := 100.000000000000000000;
    cbSpravnaB.WidthPercent := 100.000000000000000000;
    cbSpravnaC.SetParentComponent(Self);
    cbSpravnaC.Name := 'cbSpravnaC';
    cbSpravnaC.Left := 852;
    cbSpravnaC.Top := 360;
    cbSpravnaC.Width := 25;
    cbSpravnaC.Height := 22;
    cbSpravnaC.ChildOrder := 11;
    cbSpravnaC.HeightPercent := 100.000000000000000000;
    cbSpravnaC.WidthPercent := 100.000000000000000000;
    cbSpravnaD.SetParentComponent(Self);
    cbSpravnaD.Name := 'cbSpravnaD';
    cbSpravnaD.Left := 852;
    cbSpravnaD.Top := 424;
    cbSpravnaD.Width := 25;
    cbSpravnaD.Height := 22;
    cbSpravnaD.ChildOrder := 11;
    cbSpravnaD.HeightPercent := 100.000000000000000000;
    cbSpravnaD.WidthPercent := 100.000000000000000000;
    cbSpravnaE.SetParentComponent(Self);
    cbSpravnaE.Name := 'cbSpravnaE';
    cbSpravnaE.Left := 852;
    cbSpravnaE.Top := 504;
    cbSpravnaE.Width := 25;
    cbSpravnaE.Height := 22;
    cbSpravnaE.ChildOrder := 11;
    cbSpravnaE.HeightPercent := 100.000000000000000000;
    cbSpravnaE.WidthPercent := 100.000000000000000000;
    cbSpravnaF.SetParentComponent(Self);
    cbSpravnaF.Name := 'cbSpravnaF';
    cbSpravnaF.Left := 852;
    cbSpravnaF.Top := 576;
    cbSpravnaF.Width := 25;
    cbSpravnaF.Height := 22;
    cbSpravnaF.ChildOrder := 11;
    cbSpravnaF.HeightPercent := 100.000000000000000000;
    cbSpravnaF.WidthPercent := 100.000000000000000000;
    cbSpravnaG.SetParentComponent(Self);
    cbSpravnaG.Name := 'cbSpravnaG';
    cbSpravnaG.Left := 852;
    cbSpravnaG.Top := 648;
    cbSpravnaG.Width := 25;
    cbSpravnaG.Height := 22;
    cbSpravnaG.ChildOrder := 11;
    cbSpravnaG.HeightPercent := 100.000000000000000000;
    cbSpravnaG.WidthPercent := 100.000000000000000000;
    cbSpravnaH.SetParentComponent(Self);
    cbSpravnaH.Name := 'cbSpravnaH';
    cbSpravnaH.Left := 852;
    cbSpravnaH.Top := 712;
    cbSpravnaH.Width := 25;
    cbSpravnaH.Height := 22;
    cbSpravnaH.ChildOrder := 11;
    cbSpravnaH.HeightPercent := 100.000000000000000000;
    cbSpravnaH.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 150;
    WebPanel1.Height := 882;
    WebPanel1.Align := alLeft;
    WebPanel1.ChildOrder := 4;
    WebPanel1.Color := 16765066;
    WebPanel1.TabOrder := 10;
    btnUlozit.SetParentComponent(WebPanel1);
    btnUlozit.Name := 'btnUlozit';
    btnUlozit.Left := 14;
    btnUlozit.Top := 20;
    btnUlozit.Width := 121;
    btnUlozit.Height := 41;
    btnUlozit.Caption := 'Ulo'#382'i'#357;
    btnUlozit.Color := 16763647;
    btnUlozit.HeightPercent := 100.000000000000000000;
    btnUlozit.TabOrder := 0;
    btnUlozit.WidthPercent := 100.000000000000000000;
    SetEvent(btnUlozit, Self, 'OnClick', 'btnUlozitClick');
    WebSpeedButton2.SetParentComponent(WebPanel1);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 14;
    WebSpeedButton2.Top := 69;
    WebSpeedButton2.Width := 121;
    WebSpeedButton2.Height := 41;
    WebSpeedButton2.Caption := 'N'#225'vrat';
    WebSpeedButton2.Color := 16763647;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    mTextOtazky.SetParentComponent(Self);
    mTextOtazky.Name := 'mTextOtazky';
    mTextOtazky.Left := 272;
    mTextOtazky.Top := 83;
    mTextOtazky.Width := 513;
    mTextOtazky.Height := 65;
    mTextOtazky.Font.Charset := DEFAULT_CHARSET;
    mTextOtazky.Font.Color := clWindowText;
    mTextOtazky.Font.Height := -17;
    mTextOtazky.Font.Name := 'Segoe UI';
    mTextOtazky.Font.Style := [];
    mTextOtazky.HeightPercent := 100.000000000000000000;
    mTextOtazky.Lines.BeginUpdate;
    try
      mTextOtazky.Lines.Clear;
      mTextOtazky.Lines.Add('mTextOtazky');
    finally
      mTextOtazky.Lines.EndUpdate;
    end;
    mTextOtazky.ParentFont := False;
    mTextOtazky.ScrollBars := ssNone;
    mTextOtazky.SelLength := 0;
    mTextOtazky.SelStart := 0;
    mTextOtazky.WidthPercent := 100.000000000000000000;
    eOdpovedA.SetParentComponent(Self);
    eOdpovedA.Name := 'eOdpovedA';
    eOdpovedA.Left := 272;
    eOdpovedA.Top := 197;
    eOdpovedA.Width := 513;
    eOdpovedA.Height := 65;
    eOdpovedA.Font.Charset := DEFAULT_CHARSET;
    eOdpovedA.Font.Color := clWindowText;
    eOdpovedA.Font.Height := -17;
    eOdpovedA.Font.Name := 'Segoe UI';
    eOdpovedA.Font.Style := [];
    eOdpovedA.HeightPercent := 100.000000000000000000;
    eOdpovedA.ParentFont := False;
    eOdpovedA.ScrollBars := ssNone;
    eOdpovedA.SelLength := 0;
    eOdpovedA.SelStart := 0;
    eOdpovedA.WidthPercent := 100.000000000000000000;
    eOdpovedB.SetParentComponent(Self);
    eOdpovedB.Name := 'eOdpovedB';
    eOdpovedB.Left := 272;
    eOdpovedB.Top := 268;
    eOdpovedB.Width := 513;
    eOdpovedB.Height := 65;
    eOdpovedB.Font.Charset := DEFAULT_CHARSET;
    eOdpovedB.Font.Color := clWindowText;
    eOdpovedB.Font.Height := -17;
    eOdpovedB.Font.Name := 'Segoe UI';
    eOdpovedB.Font.Style := [];
    eOdpovedB.HeightPercent := 100.000000000000000000;
    eOdpovedB.ParentFont := False;
    eOdpovedB.ScrollBars := ssNone;
    eOdpovedB.SelLength := 0;
    eOdpovedB.SelStart := 0;
    eOdpovedB.WidthPercent := 100.000000000000000000;
    eOdpovedC.SetParentComponent(Self);
    eOdpovedC.Name := 'eOdpovedC';
    eOdpovedC.Left := 272;
    eOdpovedC.Top := 339;
    eOdpovedC.Width := 513;
    eOdpovedC.Height := 65;
    eOdpovedC.Font.Charset := DEFAULT_CHARSET;
    eOdpovedC.Font.Color := clWindowText;
    eOdpovedC.Font.Height := -17;
    eOdpovedC.Font.Name := 'Segoe UI';
    eOdpovedC.Font.Style := [];
    eOdpovedC.HeightPercent := 100.000000000000000000;
    eOdpovedC.ParentFont := False;
    eOdpovedC.ScrollBars := ssNone;
    eOdpovedC.SelLength := 0;
    eOdpovedC.SelStart := 0;
    eOdpovedC.WidthPercent := 100.000000000000000000;
    eOdpovedD.SetParentComponent(Self);
    eOdpovedD.Name := 'eOdpovedD';
    eOdpovedD.Left := 272;
    eOdpovedD.Top := 410;
    eOdpovedD.Width := 513;
    eOdpovedD.Height := 65;
    eOdpovedD.Font.Charset := DEFAULT_CHARSET;
    eOdpovedD.Font.Color := clWindowText;
    eOdpovedD.Font.Height := -17;
    eOdpovedD.Font.Name := 'Segoe UI';
    eOdpovedD.Font.Style := [];
    eOdpovedD.HeightPercent := 100.000000000000000000;
    eOdpovedD.ParentFont := False;
    eOdpovedD.ScrollBars := ssNone;
    eOdpovedD.SelLength := 0;
    eOdpovedD.SelStart := 0;
    eOdpovedD.WidthPercent := 100.000000000000000000;
    eOdpovedE.SetParentComponent(Self);
    eOdpovedE.Name := 'eOdpovedE';
    eOdpovedE.Left := 272;
    eOdpovedE.Top := 481;
    eOdpovedE.Width := 513;
    eOdpovedE.Height := 65;
    eOdpovedE.Font.Charset := DEFAULT_CHARSET;
    eOdpovedE.Font.Color := clWindowText;
    eOdpovedE.Font.Height := -17;
    eOdpovedE.Font.Name := 'Segoe UI';
    eOdpovedE.Font.Style := [];
    eOdpovedE.HeightPercent := 100.000000000000000000;
    eOdpovedE.ParentFont := False;
    eOdpovedE.ScrollBars := ssNone;
    eOdpovedE.SelLength := 0;
    eOdpovedE.SelStart := 0;
    eOdpovedE.WidthPercent := 100.000000000000000000;
    eOdpovedF.SetParentComponent(Self);
    eOdpovedF.Name := 'eOdpovedF';
    eOdpovedF.Left := 272;
    eOdpovedF.Top := 552;
    eOdpovedF.Width := 513;
    eOdpovedF.Height := 65;
    eOdpovedF.Font.Charset := DEFAULT_CHARSET;
    eOdpovedF.Font.Color := clWindowText;
    eOdpovedF.Font.Height := -17;
    eOdpovedF.Font.Name := 'Segoe UI';
    eOdpovedF.Font.Style := [];
    eOdpovedF.HeightPercent := 100.000000000000000000;
    eOdpovedF.ParentFont := False;
    eOdpovedF.ScrollBars := ssNone;
    eOdpovedF.SelLength := 0;
    eOdpovedF.SelStart := 0;
    eOdpovedF.WidthPercent := 100.000000000000000000;
    eOdpovedG.SetParentComponent(Self);
    eOdpovedG.Name := 'eOdpovedG';
    eOdpovedG.Left := 272;
    eOdpovedG.Top := 623;
    eOdpovedG.Width := 513;
    eOdpovedG.Height := 65;
    eOdpovedG.Font.Charset := DEFAULT_CHARSET;
    eOdpovedG.Font.Color := clWindowText;
    eOdpovedG.Font.Height := -17;
    eOdpovedG.Font.Name := 'Segoe UI';
    eOdpovedG.Font.Style := [];
    eOdpovedG.HeightPercent := 100.000000000000000000;
    eOdpovedG.ParentFont := False;
    eOdpovedG.ScrollBars := ssNone;
    eOdpovedG.SelLength := 0;
    eOdpovedG.SelStart := 0;
    eOdpovedG.WidthPercent := 100.000000000000000000;
    eOdpovedH.SetParentComponent(Self);
    eOdpovedH.Name := 'eOdpovedH';
    eOdpovedH.Left := 272;
    eOdpovedH.Top := 694;
    eOdpovedH.Width := 513;
    eOdpovedH.Height := 65;
    eOdpovedH.Font.Charset := DEFAULT_CHARSET;
    eOdpovedH.Font.Color := clWindowText;
    eOdpovedH.Font.Height := -17;
    eOdpovedH.Font.Name := 'Segoe UI';
    eOdpovedH.Font.Style := [];
    eOdpovedH.HeightPercent := 100.000000000000000000;
    eOdpovedH.ParentFont := False;
    eOdpovedH.ScrollBars := ssNone;
    eOdpovedH.SelLength := 0;
    eOdpovedH.SelStart := 0;
    eOdpovedH.WidthPercent := 100.000000000000000000;
    WebClientConnection3.SetParentComponent(Self);
    WebClientConnection3.Name := 'WebClientConnection3';
    WebClientConnection3.Active := False;
    WebClientConnection3.Command := httpPOST;
    WebClientConnection3.DataNode := 'ROW';
    WebClientConnection3.Delimiter := ';';
    WebClientConnection3.URI := 'http://192.168.0.62:9998/userread';
    SetEvent(WebClientConnection3, Self, 'OnDataReceived', 'WebClientConnection3DataReceived');
    WebClientConnection3.Left := 668;
    WebClientConnection3.Top := 24;
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    eRozsah.AfterLoadDFMValues;
    eCislo.AfterLoadDFMValues;
    cbSpravnaA.AfterLoadDFMValues;
    cbSpravnaB.AfterLoadDFMValues;
    cbSpravnaC.AfterLoadDFMValues;
    cbSpravnaD.AfterLoadDFMValues;
    cbSpravnaE.AfterLoadDFMValues;
    cbSpravnaF.AfterLoadDFMValues;
    cbSpravnaG.AfterLoadDFMValues;
    cbSpravnaH.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnUlozit.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    mTextOtazky.AfterLoadDFMValues;
    eOdpovedA.AfterLoadDFMValues;
    eOdpovedB.AfterLoadDFMValues;
    eOdpovedC.AfterLoadDFMValues;
    eOdpovedD.AfterLoadDFMValues;
    eOdpovedE.AfterLoadDFMValues;
    eOdpovedF.AfterLoadDFMValues;
    eOdpovedG.AfterLoadDFMValues;
    eOdpovedH.AfterLoadDFMValues;
    WebClientConnection3.AfterLoadDFMValues;
  end;
end;

end.
